import { Component, Input } from '@angular/core';
import { FeatureConfigFacade } from '@common/data-access-feature-config';
import { CoverType, QuoteCms } from '@common/util-models';
import { QuoteDocument } from '@domgen/dgx-fe-business-models';
import { Observable } from 'rxjs';

@Component({
  selector: 'wl-need-to-know',
  templateUrl: './need-to-know.component.html',
  styleUrls: ['./need-to-know.component.scss'],
})
export class NeedToKnowComponent {
  @Input() cmsData!: QuoteCms | null | undefined;
  @Input() productInfo: QuoteDocument | undefined = undefined;
  @Input() terms: QuoteDocument | undefined = undefined;
  @Input() policy: QuoteDocument | undefined = undefined;
  @Input() isInsurance: boolean | null = false;
  @Input() displayTCLink = true;
  @Input() coverType!: CoverType | null;

  mobileVIPJourney$: Observable<boolean>;

  brandName = 'Sky Protect';

  constructor(private readonly featureConfigFacade: FeatureConfigFacade) {
    this.mobileVIPJourney$ = this.featureConfigFacade.isMobileVIPJourney$;
  }

  get content() {
    let content = '';

    this.mobileVIPJourney$.subscribe((isMobileVIPJourney) => {
      content =
        this.cmsData?.[
          isMobileVIPJourney ? 'needToKnowVIPMobile' : 'needToKnow'
        ]?.replace(/\n/g, '<br/>') || '';
    });

    return content;
  }
}
